import { render, staticRenderFns } from "./NewCandidateList.vue?vue&type=template&id=3cd1dcce&scoped=true"
import script from "./NewCandidateList.vue?vue&type=script&lang=js"
export * from "./NewCandidateList.vue?vue&type=script&lang=js"
import style0 from "./NewCandidateList.vue?vue&type=style&index=0&id=3cd1dcce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd1dcce",
  null
  
)

export default component.exports